export default __webpack_public_path__ + "static/media/pelagiadregular.1957896c.txt";